import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Chip, Typography } from '@mui/material';
import { useState } from 'react';
import { UseFieldArrayReturn, useFormContext } from 'react-hook-form';

import { CommonPageForm } from '../../../../../page-builder-v2.types';
import { ReviewsForm } from './components';
import { styles } from './product-reviews-subsection.styles';

type Props = {
  currentProductId: string;
  productFields: UseFieldArrayReturn<CommonPageForm, 'products', 'id'>
};

const ProductReviewSubsection = ({ currentProductId, productFields }: Props) => {
  const { control } = useFormContext<CommonPageForm>();
  const [expanded, setExpanded] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);

  const currentProduct = productFields.fields.find(
    (f) => f.product_id === currentProductId && f.status !== 'excluded',
  );
  const reviewCount = currentProduct?.reviews?.reviews?.length ?? 0;

  const handleAddClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setExpanded(true);
    setDialogOpen(true);
  };

  return (
    <Accordion disableGutters expanded={expanded} onChange={() => setExpanded(!expanded)} sx={styles.accordion}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={styles.accordionSummary}>
        <Box sx={styles.accordionHeader}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Typography fontWeight={600} variant="subtitle1">Reviews</Typography>
            {reviewCount > 0 && (
              <Chip color="primary" label={reviewCount} size="small" variant="outlined" />
            )}
          </Box>
          <Button
            onClick={handleAddClick}
            size="small"
            startIcon={<AddIcon />}
            sx={{ mr: 1 }}
            variant="outlined"
          >
            Add
          </Button>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={styles.accordionDetails}>
        {productFields.fields.map((field, productIdx) => {
          if (field.product_id !== currentProductId || field.status === 'excluded') return null;
          return (
            <ReviewsForm
              key={field.product_id}
              control={control}
              onClose={() => setDialogOpen(false)}
              open={dialogOpen}
              productIdx={productIdx}
            />
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
};

export { ProductReviewSubsection };
